import { LucideIcon } from "lucide-react";

interface EmptyStateProps {
  title: string;
  description: string;
  icon?: LucideIcon;
  iconClassName?: string;
  containerClassName?: string;
}

export function EmptyState({ 
  title, 
  description, 
  icon: Icon,
  iconClassName = "w-8 h-8 text-gray-400",
  containerClassName = ""
}: EmptyStateProps) {
  return (
    <div className={`flex flex-col items-center justify-center py-8 text-center ${containerClassName}`}>
      {Icon && <Icon className={`${iconClassName} mb-2`} />}
      <h3 className="text-lg font-medium text-gray-900 mb-1">
        {title}
      </h3>
      <p className="text-sm text-gray-500 max-w-md">
        {description}
      </p>
    </div>
  );
}
